module.exports = __webpack_public_path__ + "img/contact_icon.5b175914.png";